import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, throwError } from 'rxjs';

import { AuthActions } from '../../features/auth/store';
import { SKIP_ERROR_HANDLING } from '../http/http-context';
import { NotificationService } from '../services/notification.service';
import { getApiErrorMessage, isHttpErrorResponse, toApiError } from '../utils/api-error.util';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notification = inject(NotificationService);
  const store = inject(Store);
  const skipHandling = req.context.get(SKIP_ERROR_HANDLING);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (isHttpErrorResponse(error) && error.status === 401) {
        store.dispatch(AuthActions.unauthorized());

        return throwError(() => toApiError(error));
      }

      if (!skipHandling) {
        notification.showApiError(getApiErrorMessage(error));
      }

      if (isHttpErrorResponse(error)) {
        return throwError(() => toApiError(error));
      }

      return throwError(() => error);
    }),
  );
};
